import * as InviteActions from '../actions/InviteActions'
import {PENDING, FULFILLED} from '../actions/constants';
import update from 'immutability-helper';

export default (state = {
    fetched: false,
    fetchedSingle: false,
    fetching: false,
    creating: false,
    items: {},
}, action) => {
    switch (action.type){
        case InviteActions.FETCH_TEAM_INVITE + PENDING:
            return update(state, {
                fetching: {$set: true}
            });
        case InviteActions.FETCH_TEAM_INVITE + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                fetching: {$set: false},
                fetchedSingle: {$set: true}
            });
        case InviteActions.FETCH_TEAM_INVITES + PENDING:
            return update(state, {
                fetching: {$set: true}
            });
        case InviteActions.FETCH_TEAM_INVITES + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                fetching: {$set: false},
                fetched: {$set: true}
            });

        case InviteActions.CREATE_TEAM_INVITE + PENDING:
            return update(state, {
                creating: {$set: true}
            })

        case InviteActions.CREATE_TEAM_INVITE + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                creating: {$set: false}
            })

        case InviteActions.DELETE_TEAM_INVITE + FULFILLED:
            return update(state, {
                items: {$unset: [action.meta.id]},
            });

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/InvitesReducer.js